// shared/domain/compresion.js  (reglas puras de la compresión de imágenes en el cliente; sin DOM)

/** Perfil acordado: lado mayor 1920 px, JPEG calidad 0.8, tope de 1 MB por imagen subida; las chicas no se tocan. */
export const PERFIL_IMAGEN = {
  ladoMayor: 1920,
  calidad: 0.8,
  topeBytes: 1024 * 1024,
  umbralChicaBytes: 300 * 1024,
  ladoMayorRespaldo: 1600,
};

/** Dimensiones enteras que conservan la proporción con el lado mayor limitado a `ladoMayor`; nunca amplía. */
export const calcularDimensiones = (width, height, ladoMayor = PERFIL_IMAGEN.ladoMayor) => {
  const w = Math.max(1, Math.round(width));
  const h = Math.max(1, Math.round(height));
  const mayor = Math.max(w, h);
  if (mayor <= ladoMayor) return { width: w, height: h };
  const escala = ladoMayor / mayor;
  return { width: Math.max(1, Math.round(w * escala)), height: Math.max(1, Math.round(h * escala)) };
};

/** false si la imagen ya es chica (peso y dimensiones): se conserva el original, incluido un PNG. */
export const necesitaCompresion = ({ size, width, height }) =>
  !(size <= PERFIL_IMAGEN.umbralChicaBytes && Math.max(width, height) <= PERFIL_IMAGEN.ladoMayor);

/** Intentos en orden: de mejor a menor calidad/tamaño hasta que el resultado quepa en `topeBytes`. */
export const intentosCompresion = () => {
  const { ladoMayor, ladoMayorRespaldo } = PERFIL_IMAGEN;
  return [
    { lado: ladoMayor, q: 0.8 },
    { lado: ladoMayor, q: 0.7 },
    { lado: ladoMayor, q: 0.6 },
    { lado: ladoMayorRespaldo, q: 0.7 },
    { lado: ladoMayorRespaldo, q: 0.6 },
    { lado: ladoMayorRespaldo, q: 0.5 },
  ];
};

/** Mismo nombre con extensión .jpg (agrega .jpg si no tenía extensión). */
export const nombreJpg = nombre => {
  const base = String(nombre || 'imagen');
  const punto = base.lastIndexOf('.');
  return `${punto > 0 ? base.slice(0, punto) : base}.jpg`;
};
